import React, {} from 'react';

import nodeControls from '../../node-menu/control-types';
import BaseElement from '../base';

import { determineBaseProperties } from '../utilities';
import { formatLastUpdatedAt } from './utilities';

function LastUpdated(props) {

  const baseElementProperties = determineBaseProperties({
    ...props,
    customNodeControls: [
      nodeControls.ALIGNMENT
    ]
  }, nodeControls);

  function renderMain() {

    const attributes = {
      ...props.attributes,
      className: '',
      contentEditable: false
    };

    return <div {...attributes}>
      <div className="last-updated">
        <label className="last-updated-label sub-text">Last Updated:</label>
        <span className="last-updated-value sub-text">{formatLastUpdatedAt(props.element.properties.lastUpdatedAt)}</span>
      </div>
      {props.children}
    </div>;

  }

  return <BaseElement {...baseElementProperties}>
    {renderMain()}
  </BaseElement>;

}

export default LastUpdated;